module.exports = __webpack_public_path__ + "static/media/login.69424065.mp4";